import React from 'react'
import Top from '../../components/common/Top'
import AreatorViews from '../../components/common/AreatorViews'
import {  } from '../../utils/api'
import Footer from "../../components/common/Footer";
import {Anchor} from "antd";
const { Link } = Anchor;

class Areatoraise extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {

    }
    render() {
        const {  } = this.state
        return (
            <div className="areatoraise">
                <Top />
                <div className="col-lg-2"></div>
                <div className="col-lg-8" style={{marginBottom:'2em'}}>
                    <AreatorViews/>
                </div>
                <div className="col-lg-2"></div>
                <Footer/>
            </div >
        )
    }

}

export default Areatoraise
